// extracted by mini-css-extract-plugin
export default {"container":"RelatedVideoUploadForm_container__rtdCk","form":"RelatedVideoUploadForm_form__IXf4K","message":"RelatedVideoUploadForm_message__6Gs7j"};